"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_apollo_1 = require("react-apollo");
const onboarding_1 = require("@atlaskit/onboarding");
const onboardingQuery = require("./onboarding.query.graphql");
const markOnboardingFlagMutation = require("./mark-onboarding-flag.mutation.graphql");
const utilities_1 = require("../utilities");
const defaultContext = {
    setStep: _ => { },
    endFlow: _ => { },
    registerOnboardingFlow: _ => { },
    unregisterOnboardingFlow: _ => { },
    spotlightDidRender: () => { }
};
exports.OnboardingContext = React.createContext(defaultContext);
class OnboardingContextProviderView extends React.Component {
    constructor() {
        super(...arguments);
        this.getCurrentSpotlight = (flow, step) => `${flow}-${step}`;
        this.setStep = (newStep) => {
            const { flows, context } = this.state;
            const currentFlow = flows[0];
            this.setState({
                isWaitingForNextStep: true,
                currentStep: newStep,
                context: Object.assign(Object.assign({}, context), { currentSpotlight: this.getCurrentSpotlight(currentFlow, newStep) })
            });
            // If the current onboarding flow stalls then we want to end it
            setTimeout(() => {
                if (this.state.isWaitingForNextStep) {
                    this.endFlow(currentFlow);
                }
            }, 5000);
        };
        this.endFlow = (id) => {
            this.props.markOnboardingFlag({
                variables: {
                    flag: id
                }
            });
            const flows = this.state.flows.slice(1);
            this.setState({
                flows,
                currentStep: 0,
                context: Object.assign(Object.assign({}, this.state.context), { currentSpotlight: this.getCurrentSpotlight(flows[0], 0) })
            });
        };
        this.registerOnboardingFlow = (id) => {
            if (this.props.data.loading) {
                setTimeout(() => this.registerOnboardingFlow(id), 1000);
            }
            else if (!this.props.data.onboarding.flags.includes(id) &&
                !this.state.flows.includes(id)) {
                const flows = [...this.state.flows, id];
                this.setState({
                    flows,
                    context: Object.assign(Object.assign({}, this.state.context), { currentSpotlight: this.getCurrentSpotlight(flows[0], this.state.currentStep) })
                });
            }
        };
        this.unregisterOnboardingFlow = (id) => {
            if (id !== this.state.flows[0]) {
                const flows = this.state.flows.filter(flow => flow !== id);
                this.setState({
                    flows,
                    context: Object.assign(Object.assign({}, this.state.context), { currentSpotlight: this.getCurrentSpotlight(flows[0], this.state.currentStep) })
                });
            }
        };
        this.spotlightDidRender = () => {
            this.setState({
                isWaitingForNextStep: false
            });
        };
        this.state = {
            flows: [],
            currentStep: 0,
            isWaitingForNextStep: false,
            context: {
                setStep: this.setStep,
                endFlow: this.endFlow,
                registerOnboardingFlow: this.registerOnboardingFlow,
                unregisterOnboardingFlow: this.unregisterOnboardingFlow,
                spotlightDidRender: this.spotlightDidRender
            }
        };
    }
    render() {
        const { children } = this.props;
        return (React.createElement(onboarding_1.SpotlightManager, null,
            React.createElement(onboarding_1.SpotlightTransition, null,
                React.createElement(exports.OnboardingContext.Provider, { value: this.state.context }, children))));
    }
}
exports.OnboardingContextProviderView = OnboardingContextProviderView;
exports.OnboardingContextProvider = utilities_1.compose(react_apollo_1.graphql(onboardingQuery), react_apollo_1.graphql(markOnboardingFlagMutation, {
    name: "markOnboardingFlag"
}))(OnboardingContextProviderView);
